@if (product) {
  <div class="row gy-3" >
    @if (product.selectableDimensions) {
      <div class="col-12">
        @if (form) {
          <form novalidate [formGroup]="form">
            <div class="selectable-dimensions">
              @for (dimension of product.selectableDimensions; track dimension; let index = $index) {
                <div class="dimension">
                  <div class="dimension-label">
                    <span class="label">
                      {{ dimension.title }}
                      @if (allowDimensionSelection(dimension)) {
                        @if (dimension.dimensionId == fetchingDimensionId) {
                          <gea-svg-loading />
                        }
                        @if (dimension.dimensionId != fetchingDimensionId && (isFieldValid(dimension.dimensionId) == false || this.errorDimensionId == dimension.dimensionId)) {
                          <gea-svg-error />
                        }
                        @if (dimension.dimensionId != fetchingDimensionId && isFieldValid(dimension.dimensionId) && this.errorDimensionId != dimension.dimensionId && hasSelection(dimension.dimensionId)) {
                          <gea-svg-success />
                        }
                      }
                    </span>
                  </div>
                  @for (option of getDistinctOptions(dimension); track option) {
                    <!-- swatch -->
                    @if (option.imageSlug) {
                      <span
                        class="swatch-color bold"
                        ngbTooltip="{{ option.label }}" placement="bottom-left"
                        [class.disabled]="index != 0 && allowOptionSelection(dimension, option.optionId) == false"
                        [class.selected]="isOptionSelected(dimension, option.optionId)"
                        (click)="selectDimensionOption(dimension, option.optionId)"
                        >
                        <img
                          [ngSrc]="option.imageSlug"
                          [attr.alt]="option.label"
                          class="img-fluid img-round"
                          ngSrcset="18w, 32w"
                          width="30"
                          height="30"
                          />
                      </span>
                    } @else {
                      <div
                        [ngbTooltip]="getOptionTooltipImage(dimension, option.optionId) ? toolTipImage : null" placement="bottom-left"
                        [class.disabled]="index !== 0 && !allowOptionSelection(dimension, option.optionId)"
                        [class.selected]="isOptionSelected(dimension, option.optionId)"
                        (click)="selectDimensionOption(dimension, option.optionId)"
                        class="tile"
                        >
                        {{ option.label }}{{ dimension.unit ? (' ' + dimension.unit) : '' }}
                      </div>
                      <ng-template #toolTipImage>
                        @if (getOptionTooltipImage(dimension, option.optionId); as image) {
                          <img
                            src="{{getImageLink(image)}}"
                            [attr.alt]=""
                            class="img-fluid"
                            />
                        }
                      </ng-template>
                    }
                    <!-- no-swatch -->
                  }
                </div>
              }
            </div>
          </form>
        }
      </div>
    }
  </div>
}
